import { UserCircle } from '@phosphor-icons/react'
import React from 'react'
import { sideNavAnalyticsProps } from '../side-nav-analytics-props'
import { useIsActive } from 'app/packs/src/utils/use-is-active'
import * as SideMenu from 'components/side-menu'

type UserPersonalSkillsLinkProps = {
  className?: string
  userSlug: string
}

export const UserPersonalSkillsLink: React.FC<UserPersonalSkillsLinkProps> = (
  props
) => {
  const { className, userSlug } = props
  const title = 'Personal Skills'

  const path = `/users/${userSlug}/personal_skills`

  return (
    <SideMenu.LinkItem
      active={useIsActive(path)}
      analyticsProps={sideNavAnalyticsProps({
        href: path,
        title,
      })}
      className={className}
      href={path}
      icon={UserCircle}
    >
      {title}
    </SideMenu.LinkItem>
  )
}
